import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Login from './components/Login';
import Layout from './components/Layout';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import PullSheet from './pages/PullSheet';
import Inventory from './pages/Inventory';
import ItemHistory from './pages/ItemHistory';
import Kits from './pages/Kits';
import PrintLabel from './pages/PrintLabel';
import CodeGapsReport from './pages/CodeGapsReport';
import Categories from './pages/Categories';
import MediaManagement from './pages/MediaManagement';
import MediaStatusPublic from './pages/MediaStatusPublic';
import { LOGO_URL } from './mock';
import { Toaster } from './components/ui/sonner';

function Splash() {
  return (
    <div className="whip-bg min-h-screen flex flex-col items-center justify-center">
      <img src={LOGO_URL} alt="Whiplash" className="h-12 mb-4 opacity-90" />
      <div className="text-[10px] tracking-[0.35em] text-neutral-500 uppercase animate-pulse">
        Loading
      </div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useApp();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, initializing } = useApp();
  if (initializing) return <Splash />;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      {/* Public media status page — hit by phone-camera scans of the media QR. */}
      <Route path="/m/:code" element={<MediaStatusPublic />} />
      <Route
        path="/projects/:id/pull-sheet"
        element={
          <ProtectedRoute>
            <PullSheet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/print-label/:kind/:code"
        element={
          <ProtectedRoute>
            <PrintLabel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Projects />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="inventory/:code" element={<ItemHistory />} />
        <Route path="kits" element={<Kits />} />
        <Route path="reports/code-gaps" element={<CodeGapsReport />} />
        <Route path="settings/categories" element={<Categories />} />
        <Route path="media" element={<MediaManagement />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster theme="dark" position="bottom-right" richColors closeButton />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
